import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { changeRecommendationType } from '../../actions/spaces/RecommendationTypeAction';
import { selectRecommendationType } from '../../selectors/RecommendationTypeSelector';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { RecommendationSpaceDispatchProps, RecommendationsSpace, RecommendationsSpaceStateProps } from './RecommendationsSpace';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

const mapStateToProps: MapStateToProps<RecommendationsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  recommendationType: selectRecommendationType(state)
});

const mapDispatchToProps: MapDispatchToProps<RecommendationSpaceDispatchProps> = (dispatch) => bindActionCreators({
  recommendationTypeSelected: changeRecommendationType
}, dispatch);

export const ConnectedRecommendationsSpace: React.ComponentClass<ReactDirectiveProps>
  = connect(mapStateToProps, mapDispatchToProps)(RecommendationsSpace);
